import { Handle, type NodeProps } from "@xyflow/react";
import type { LiteralNodeData } from "@/types/decision-graph";
import { getHandlePositions } from "../utils/handle-positions";

export function LiteralNode({ data }: NodeProps) {
  const d = data as LiteralNodeData;
  const { outputPosition } = getHandlePositions(d.layoutDirection);

  return (
    <div className="rounded-md border border-blue-300 bg-blue-50 px-3 py-2 text-xs shadow-sm min-w-[100px]">
      <div className="font-medium text-blue-700 text-[10px] mb-0.5">
        LITERAL
      </div>
      <div className="text-blue-900 font-mono">
        {d.value === null ? "null" : String(d.value)}
      </div>
      <Handle type="source" position={outputPosition} id="result" />
    </div>
  );
}
